import { Component, inject, OnInit } from '@angular/core';

import { ApContentService } from '@ap/content';
import { MijnLaunchDarklyService } from '@ap/mijn-kanaalconfiguratie';

import { ErrorContext } from '../../klant/login/error/error.model';
import { BrowsercodeHerstelWrapperService } from '../browsercode-herstel/browsercode-herstel.wrapper.service';
import { LoginEnabledService } from '../login-enabled-guard/login-enabled.service';
import { MijnLoginNavigation } from '../mijn-login.navigation';
import { MijnLoginService } from '../mijn-login.service';

import content from './error.wrapper.content.json';

/**
 * @ngdoc component
 * @name ErrorWrapperComponent
 * @module ErrorWrapperModule
 */
@Component({
    selector: 'error',
    templateUrl: './error.wrapper.component.html',
    standalone: false
})
export class ErrorWrapperComponent implements OnInit {
    public context: ErrorContext;

    private readonly contentService: ApContentService = inject(ApContentService);
    private readonly browsercodeHerstelWrapperService: BrowsercodeHerstelWrapperService = inject(BrowsercodeHerstelWrapperService);
    private readonly loginEnabledService: LoginEnabledService = inject(LoginEnabledService);
    private readonly mijnLoginNavigation: MijnLoginNavigation = inject(MijnLoginNavigation);
    private readonly mijnLoginService: MijnLoginService = inject(MijnLoginService);

    private readonly launchDarklyService: MijnLaunchDarklyService = inject(MijnLaunchDarklyService);

    public ngOnInit(): void {
        this.contentService.addContentItems(content);

        this.loginEnabledService.isEnabled().subscribe((isEnabled) => {
            this.context = this.mijnLoginService.getErrorContext();

            if (isEnabled && (this.context === ErrorContext.DISABLED_MAINTENANCE || this.context === ErrorContext.DISABLED_DISRUPTION)) {
                this.mijnLoginNavigation.toLogin();
            }
        });
    }

    public doAction(): void {
        if (this.context === ErrorContext.BROWSERTOKEN) {
            this.toBrowserRegistration();
        } else if (this.isDisabled()) {
            this.mijnLoginNavigation.external(this.contentService.get('mijn.login.error.wrapper.disabled.link'));
        } else {
            this.mijnLoginNavigation.toLogin();
        }
    }

    private toBrowserRegistration(): void {
        this.browsercodeHerstelWrapperService.removeBrowserRegistration().subscribe({
            complete: () => {
                this.mijnLoginNavigation.external(this.contentService.get('mijn.login.error.wrapper.browserToken.link'));
            }
        });
    }

    private isDisabled(): boolean {
        return (
            this.context === ErrorContext.UNDEFINED ||
            this.context === ErrorContext.DISABLED_DISRUPTION ||
            this.context === ErrorContext.DISABLED_MAINTENANCE
        );
    }
}
